// extracted by css-extract-rspack-plugin
export default {"wrapper":"_7f1c3261","imageWrapper":"_21bd79c6","button":"_595e51c4"};